module.exports = __webpack_public_path__ + "img/百香果2.f8c03414.png";